import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('layout.dashboard2');
import { HostListener, OnDestroy, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { NavigationEnd, Router } from '@angular/router';

@Component({
    selector: 'wiz-layout-dashboard2',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/layout.dashboard2/view.scss */
:host {
  display: block;
  height: 100%;
  min-width: 0;
}

.d2l-shell {
  display: flex;
  width: 100%;
  height: 100vh;
  min-height: 0;
  flex-direction: column;
  overflow: hidden;
  background: #ffffff;
  color: #152238;
  font-family: Inter, "Pretendard Variable", Pretendard, "Noto Sans KR", sans-serif;
}

.d2l-header {
  --d2l-actions-column: 254px;
  position: relative;
  z-index: 80;
  width: 100%;
  flex: 0 0 auto;
  border-bottom: 1px solid #e8edf3;
  background: rgba(255, 255, 255, 0.98);
  box-shadow: 0 2px 10px rgba(15, 37, 66, 0.04);
}

.d2l-header-inner {
  display: flex;
  width: min(100%, 1600px);
  height: 80px;
  box-sizing: border-box;
  align-items: center;
  gap: 24px;
  margin: 0 auto;
  padding: 0 32px;
}

.d2l-brand {
  display: inline-flex;
  width: 120px;
  flex: 0 0 120px;
  align-items: center;
  gap: 8px;
}

.d2l-brand img {
  display: block;
  width: 120px;
  height: auto;
}

.d2l-brand strong {
  color: #051946;
  font-size: 16px;
  font-weight: 800;
  white-space: nowrap;
}

.d2l-navigation {
  display: grid;
  min-width: 0;
  flex: 1 1 auto;
  align-self: stretch;
  align-items: center;
  gap: 8px;
  box-sizing: border-box;
  padding: 0 8px;
}

.d2l-nav-item {
  display: flex;
  height: 100%;
  min-width: 0;
  align-items: center;
  justify-content: center;
}

.d2l-nav-link {
  position: relative;
  display: inline-flex;
  height: 100%;
  align-items: center;
  color: #39465a;
  font-size: 16px;
  font-weight: 750;
  letter-spacing: -0.015em;
  text-decoration: none;
  white-space: nowrap;
}

.d2l-nav-link::after {
  position: absolute;
  right: 50%;
  bottom: 0;
  left: 50%;
  height: 3px;
  background: #176fd0;
  content: "";
  transition: right 0.18s ease, left 0.18s ease;
}

.d2l-nav-link:hover,
.d2l-nav-link.is-active {
  color: #0d5eaf;
}

.d2l-nav-link:hover::after,
.d2l-nav-link.is-active::after {
  right: 0;
  left: 0;
}

.d2l-actions {
  display: flex;
  width: var(--d2l-actions-column);
  min-width: 0;
  flex: 0 0 auto;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
}

.d2l-auth-links {
  display: inline-flex;
  min-width: 0;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
}

.d2l-auth-links a {
  display: inline-flex;
  min-height: 34px;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  color: #506077;
  padding: 0 8px;
  font-size: 13px;
  font-weight: 750;
  line-height: 1;
  text-decoration: none;
  white-space: nowrap;
}

.d2l-auth-links a:hover,
.d2l-auth-links a[aria-current=page] {
  background: #f1f7fe;
  color: #0d5eaf;
}

.d2l-workspace-link,
.d2l-menu-button {
  display: inline-flex;
  height: 38px;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  border: 1px solid #dce5ef;
  border-radius: 12px;
  background: #ffffff;
  color: #506077;
  text-decoration: none;
}

.d2l-workspace-link {
  width: 40px;
  gap: 7px;
  padding: 0;
  color: #155fae;
  font-size: 12px;
  font-weight: 750;
}

.d2l-workspace-link span,
.d2l-user-copy {
  display: none;
}

.d2l-menu-button {
  width: 38px;
  padding: 0;
  font-size: 14px;
}

.d2l-workspace-link:hover,
.d2l-menu-button:hover {
  border-color: #aac7e8;
  background: #f1f7fe;
}

.d2l-user {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 9px;
  border-radius: 14px;
  padding: 4px;
  color: #4b596d;
  text-decoration: none;
}

.d2l-user:hover {
  background: #f5f8fc;
}

.d2l-user-avatar {
  display: inline-flex;
  width: 36px;
  height: 36px;
  flex: 0 0 36px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #e8f2ff;
  color: #1268c4;
  font-size: 13px;
  font-weight: 800;
}

.d2l-user-copy {
  display: none;
  max-width: 110px;
  flex-direction: column;
}

.d2l-user-copy strong,
.d2l-user-copy small {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.d2l-user-copy strong {
  font-size: 12px;
}

.d2l-user-copy small {
  margin-top: 2px;
  color: #909cad;
  font-size: 12px;
}

.d2l-menu-button {
  display: none;
}

.d2l-mobile-menu {
  display: none;
}

.d2l-mega-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 75;
  width: 100%;
  border-top: 1px solid #edf1f5;
  border-bottom: 1px solid #e1e7ef;
  background: rgba(255, 255, 255, 0.99);
  box-shadow: 0 18px 34px rgba(16, 38, 67, 0.1);
}

.d2l-mega-inner {
  display: grid;
  width: min(100%, 1600px);
  min-height: 280px;
  box-sizing: border-box;
  grid-template-columns: 120px minmax(0, 1fr) var(--d2l-actions-column);
  gap: 24px;
  margin: 0 auto;
  padding: 14px 32px 18px;
}

.d2l-mega-grid {
  display: grid;
  min-width: 0;
  gap: 8px;
  box-sizing: border-box;
  padding: 0 8px;
}

.d2l-mega-column {
  min-width: 0;
  min-height: 224px;
  border-radius: 12px;
  padding: 13px 2px;
  transition: background-color 0.16s ease;
}

.d2l-mega-column.is-active {
  background: #f3f5f8;
}

.d2l-mega-column a {
  display: block;
  overflow: hidden;
  border-radius: 8px;
  padding: 7px 2px;
  color: #526074;
  font-size: 14px;
  font-weight: 650;
  line-height: 1.4;
  text-decoration: none;
  text-align: center;
  overflow-wrap: normal;
  white-space: normal;
  word-break: keep-all;
}

.d2l-mega-column a:hover,
.d2l-mega-column a:focus-visible {
  outline: 0;
  background: #e8f2fe;
  color: #0d5eaf;
}

.d2l-main-surface {
  width: 100%;
  min-width: 0;
  min-height: 0;
  flex: 1 1 auto;
  overflow: auto;
  background: #ffffff;
}

.d2l-global-loading {
  position: fixed;
  inset: 0;
  z-index: 120;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(15, 23, 42, 0.14);
  backdrop-filter: blur(4px);
}

@media (max-width: 1320px) {
  .d2l-header-inner {
    gap: 18px;
    padding: 0 24px;
  }
  .d2l-brand {
    width: 112px;
    flex-basis: 112px;
  }
  .d2l-brand img {
    width: 112px;
  }
  .d2l-navigation {
    gap: 14px;
    padding-right: 14px;
    padding-left: 14px;
  }
  .d2l-nav-link {
    font-size: 15px;
  }
  .d2l-workspace-link {
    width: 38px;
    padding: 0;
  }
  .d2l-mega-inner {
    grid-template-columns: 112px minmax(0, 1fr) var(--d2l-actions-column);
    gap: 18px;
    padding-right: 24px;
    padding-left: 24px;
  }
  .d2l-mega-grid {
    gap: 14px;
    padding-right: 14px;
    padding-left: 14px;
  }
}
@media (max-width: 1208px) {
  .d2l-header-inner {
    height: 68px;
    padding: 0 20px;
  }
  .d2l-navigation,
  .d2l-mega-menu,
  .d2l-workspace-link,
  .d2l-auth-links,
  .d2l-user {
    display: none;
  }
  .d2l-actions {
    width: auto;
    margin-left: auto;
  }
  .d2l-menu-button {
    display: inline-flex;
  }
  .d2l-mobile-menu {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
    max-height: calc(100vh - 68px);
    overflow-y: auto;
    border-top: 1px solid #edf1f6;
    background: #ffffff;
    padding: 14px 20px 18px;
    box-shadow: 0 16px 30px rgba(15, 37, 66, 0.1);
  }
  .d2l-mobile-menu-group {
    min-width: 0;
    overflow: hidden;
    border: 1px solid #e4eaf1;
    border-radius: 12px;
    background: #f8fafc;
  }
  .d2l-mobile-utility-group {
    background: #ffffff;
  }
  .d2l-mobile-menu-group > nav {
    display: grid;
    gap: 2px;
    border-top: 1px solid #e4eaf1;
    padding: 7px;
  }
  .d2l-mobile-menu a.d2l-mobile-menu-parent {
    display: flex;
    min-height: 48px;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    border: 0;
    border-radius: 0;
    background: transparent;
    padding: 0 15px;
    color: #44546a;
    font-size: 14px;
    font-weight: 750;
    text-decoration: none;
  }
  .d2l-mobile-menu a.d2l-mobile-menu-child {
    display: block;
    min-height: 36px;
    border-radius: 8px;
    padding: 8px 10px;
    color: #64748b;
    font-size: 13px;
    font-weight: 650;
    line-height: 20px;
    text-decoration: none;
  }
  .d2l-mobile-menu-group:has(a[aria-current=page]),
  .d2l-mobile-menu a[aria-current=page] {
    border-color: #bbd3ee;
    background: #edf5fe;
    color: #0d5eaf;
  }
  .d2l-mobile-menu i {
    color: #7b9dc2;
    font-size: 11px;
  }
}
@media (max-width: 520px) {
  .d2l-header-inner {
    padding: 0 14px;
  }
  .d2l-brand {
    width: 166px;
    flex-basis: 166px;
  }
  .d2l-brand img {
    width: 104px;
  }
  .d2l-mobile-menu {
    grid-template-columns: minmax(0, 1fr);
    padding: 12px 14px 16px;
  }
}
@media print {
  :host-context(html.report-print-active) .d2l-shell,
  :host-context(html.report-print-active) .d2l-main-surface {
    display: block;
    height: auto;
    min-height: 0;
    overflow: visible;
    background: #fff;
  }
  :host-context(html.report-print-active) .d2l-header,
  :host-context(html.report-print-active) .d2l-global-loading {
    display: none !important;
  }
}`],
})
export class LayoutDashboard2Component implements OnInit, OnDestroy {
    public mobileMenuOpen: boolean = false;
    public megaMenuOpen: boolean = false;
    public activeMenuId: string = '';
    public navigationItems: any[] = [];
    public menuGridColumns: string = '';
    private routerSub: any;
    private fragmentTimers: Set<any> = new Set();
    public showFloatingChat: boolean = true;

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    private placeholderItem(group: string, label?: string) {
        const menu = label || group;
        return {
            route: '/agent/screen-adjust',
            query: { group, menu },
            label: menu
        };
    }

    public async ngOnInit() {
        await this.service.init();
        this.navigationItems = this.buildNavigationItems();
        this.menuGridColumns = this.buildMenuGridColumns();
        this.applyLightTheme();
        this.updateFloatingChatVisibility();
        this.routerSub = this.router.events.subscribe((event: any) => {
            if (!(event instanceof NavigationEnd)) return;
            this.updateFloatingChatVisibility();
            this.scrollToCurrentFragment();
            void this.service.render();
        });
        this.scrollToCurrentFragment();
    }

    public ngOnDestroy() {
        if (this.routerSub) this.routerSub.unsubscribe();
        this.fragmentTimers.forEach(timer => clearTimeout(timer));
        this.fragmentTimers.clear();
    }

    private updateFloatingChatVisibility() {
        const path = typeof location === 'undefined' ? '' : location.pathname;
        this.showFloatingChat = !/^\/agent\/chat(?:\/|$)/.test(path) && !/^\/agent\/chat_embed(?:\/|$)/.test(path);
    }

    @HostListener('document:keydown.escape')
    public async handleEscape() {
        if (!this.mobileMenuOpen && !this.megaMenuOpen) return;
        this.mobileMenuOpen = false;
        this.megaMenuOpen = false;
        this.activeMenuId = '';
        await this.service.render();
    }

    @HostListener('window:resize')
    public async handleResize() {
        if (window.innerWidth < 1209) await this.closeMegaMenu();
        if (this.mobileMenuOpen && window.innerWidth >= 1209) this.mobileMenuOpen = false;
        await this.service.render();
    }

    private buildNavigationItems() {
        const items: any[] = [
            {
                id: 'introduction', route: '/agent/screen-adjust', query: { group: '소개', menu: '소개' }, label: '소개', match: [],
                children: [
                    this.placeholderItem('소개', '소개'),
                    this.placeholderItem('소개', '서비스 소개'),
                ]
            },
            {
                id: 'search', route: '/agent/screen-adjust', query: { group: '검색', menu: '검색' }, label: '검색', match: [],
                children: [
                    this.placeholderItem('검색', '데이터 검색'),
                    this.placeholderItem('검색', '데이터셋 검색'),
                ]
            },
            {
                id: 'models', route: '/agent/screen-adjust', query: { group: 'AI 모델', menu: 'AI 모델' }, label: 'AI 모델', match: ['/agent/analysis', '/agent/trace', '/agent/chat'],
                children: [
                    this.placeholderItem('AI 모델', '포토'),
                    this.placeholderItem('AI 모델', '식각'),
                    this.placeholderItem('AI 모델', '증착'),
                    this.placeholderItem('AI 모델', '이온주입'),
                    this.placeholderItem('AI 모델', '이상탐지'),
                    this.placeholderItem('AI 모델', '웨이퍼 결함 분류'),
                ]
            },
            {
                id: 'tools', route: '/agent/screen-adjust', query: { group: '분석 도구', menu: '분석 도구' }, label: '분석 도구', match: [],
                children: [
                    this.placeholderItem('분석 도구', 'JupyterLab'),
                    this.placeholderItem('분석 도구', '다차원 분석'),
                ]
            },
            {
                id: 'support', route: '/agent/screen-adjust', query: { group: '사용자 지원', menu: '사용자 지원' }, label: '사용자 지원', match: [],
                children: [
                    this.placeholderItem('사용자 지원', '공지사항'),
                    this.placeholderItem('사용자 지원', '자주하는 질문'),
                    this.placeholderItem('사용자 지원', '자료실'),
                ]
            },
            {
                id: 'statistics', route: '/dashboard', label: '통계', match: ['/dashboard', '/knowledge/document-results'],
                children: [
                    { route: '/dashboard', label: '데이터 현황' },
                    { route: '/agent/screen-adjust', label: '문서 전처리 비교' },
                    { route: '/knowledge/document-results', label: '문서 전처리 결과' },
                ]
            },
            {
                id: 'community', route: '/agent/screen-adjust', query: { group: '커뮤니티', menu: '커뮤니티' }, label: '커뮤니티', match: [],
                children: [
                    this.placeholderItem('커뮤니티', '기술교류·참여'),
                ]
            },
            {
                id: 'mypage', route: '/mypage', label: '마이페이지', match: ['/mypage'],
                children: [
                    { route: '/mypage', label: '마이페이지' },
                ]
            },
        ];
        if (this.isAdmin()) {
            const knowledgeMenu = items.find((item: any) => item.id === 'statistics');
            knowledgeMenu.match.push('/dashboard2', '/agent/history');
            knowledgeMenu.children.push(
                { route: '/dashboard2', label: '지식 데이터 현황' },
                { route: '/agent/history', label: '지식 데이터 관리' },
            );
        }
        return items;
    }

    private buildMenuGridColumns() {
        const weights: any = {
            introduction: 0.7,
            search: 0.7,
            models: 0.95,
            tools: 1,
            support: 1.05,
            statistics: 1,
            community: 1,
            mypage: 1,
        };
        return this.navigationItems
            .map((item: any) => `minmax(0, ${weights[item.id] || 1}fr)`)
            .join(' ');
    }

    private routeMatches(path: string, route: string) {
        return path === route || path.indexOf(`${route}/`) === 0;
    }

    public isActive(item: any) {
        const path = typeof location === 'undefined' ? '' : location.pathname;
        const childOwner = this.navigationItems.find((navigation: any) =>
            (navigation.children || []).some((child: any) => this.isChildActive(child))
        );
        if (childOwner) return childOwner.id === item?.id;
        return (item?.match || [item?.route]).some((route: string) => this.routeMatches(path, route));
    }

    public isChildActive(item: any) {
        if (typeof location === 'undefined' || !item?.route) return false;
        if (!this.routeMatches(location.pathname, item.route)) return false;
        const params = new URLSearchParams(location.search || '');
        const queryKeys = Object.keys(item.query || {});
        const defaults: any = { workspace: 'llm' };
        const queryMatches = queryKeys.length
            ? queryKeys.every((key: string) => (params.get(key) || defaults[key] || null) === String(item.query[key]))
            : !location.search;
        const fragmentMatches = item.fragment ? location.hash === `#${item.fragment}` : !location.hash;
        return queryMatches && fragmentMatches;
    }

    public languageRoute() {
        return '/agent/screen-adjust';
    }

    public languageQuery() {
        return { group: 'Language', menu: 'Language' };
    }

    public isUtilityActive(menu: string) {
        if (typeof location === 'undefined') return false;
        const params = new URLSearchParams(location.search || '');
        return location.pathname.indexOf('/agent/screen-adjust') === 0 && params.get('menu') === menu;
    }

    public navItemClass(item: any) {
        return this.isActive(item) || this.activeMenuId === item?.id ? 'd2l-nav-link is-active' : 'd2l-nav-link';
    }

    public async openMegaMenu(id: string) {
        if (typeof window !== 'undefined' && window.innerWidth < 1209) return;
        if (this.megaMenuOpen && this.activeMenuId === id) return;
        this.activeMenuId = id;
        this.megaMenuOpen = true;
        await this.service.render();
    }

    public async closeMegaMenu() {
        if (!this.megaMenuOpen && !this.activeMenuId) return;
        this.megaMenuOpen = false;
        this.activeMenuId = '';
        await this.service.render();
    }

    public megaMenuColumnClass(item: any) {
        return this.activeMenuId === item?.id ? 'd2l-mega-column is-active' : 'd2l-mega-column';
    }

    public isAdmin() {
        return this.service.auth.session?.role === 'admin';
    }

    public userInitial() {
        const name = String(this.service.auth.session?.name || this.service.auth.session?.email || 'U').trim();
        return name.charAt(0).toUpperCase() || 'U';
    }

    public userRoleLabel() {
        return this.isAdmin() ? 'Administrator' : 'Member';
    }

    private scrollToCurrentFragment(attempt: number = 0) {
        if (typeof location === 'undefined' || typeof document === 'undefined' || !location.hash) return;
        let fragment = '';
        try {
            fragment = decodeURIComponent(location.hash.slice(1));
        } catch (_error) {
            return;
        }
        if (!fragment) return;
        const timer = setTimeout(() => {
            this.fragmentTimers.delete(timer);
            const target = document.getElementById(fragment);
            if (target) {
                target.scrollIntoView({ block: 'start' });
            } else if (attempt < 4) {
                this.scrollToCurrentFragment(attempt + 1);
            }
        }, attempt === 0 ? 0 : 50);
        this.fragmentTimers.add(timer);
    }

    public async toggleMobileMenu(event?: Event) {
        if (event) event.stopPropagation();
        await this.closeMegaMenu();
        this.mobileMenuOpen = !this.mobileMenuOpen;
        await this.service.render();
    }

    public async closeMobileMenu() {
        this.mobileMenuOpen = false;
        await this.service.render();
    }

    private applyLightTheme() {
        document.documentElement.setAttribute('data-theme', 'light');
        document.documentElement.style.colorScheme = 'light';
        const meta = document.querySelector('meta[name="theme-color"]');
        if (meta) meta.setAttribute('content', '#ffffff');
        try {
            localStorage.setItem('nanofab.theme', 'light');
        } catch (_error) { }
    }
}

export default LayoutDashboard2Component;